import multiLeadSourceUrls from '@/helpers/lead-source/multiLeadSourceUrls'
import multiLeadSourceIDs from '@/assets/data/multiLeadSourceIDs'
import { NERDWALLET } from '@/helpers/constants/partner-names'
// using nerdWallet Alias as its the same for know = ['/asset', '/asset-loan']
export const homePageAlias = multiLeadSourceUrls(multiLeadSourceIDs, NERDWALLET)
